<template>
   <v-dialog v-model="dialog" persistent width="800px">
     <!-- <file-browser :dialog="iconDialog" @closeDialog="iconDialog = $event" @selectIcon="selectIcon"></file-browser> -->
     <s3-file-browser :dialog="iconDialog" @closeDialog="iconDialog = $event" @selectIcon="selectIcon"></s3-file-browser>
      <v-card class="dialog_card">
        <v-card-title style="padding: 5px 5px 5px;font-size: 12pt !important;font-weight: bold;" class="dialog_title headline grey lighten-3" primary-title>
           <v-btn style="margin-left:10px;" class="btn_add" icon small @click="dialog = false">
              <v-icon>keyboard_backspace</v-icon>
            </v-btn>
           <div class="flex-grow-1"></div>
           Header Edit
           <div class="flex-grow-1"></div>
          <v-btn icon light @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="padding:0;">
            <v-container fluid>
                <v-row  class="fill-height">
                  <div class="loading" v-if="loading">
                    <v-row align="center" justify="center" class="fill-height">
                      <v-progress-circular :size="25" :width="3" color="grey" indeterminate >
                          </v-progress-circular>
                    </v-row>
                  </div>
                <v-snackbar  v-model="errorLoading" color="error" :timeout="timeout" top="top">
                  {{errorMsg}}
                </v-snackbar>
               <v-col cols="12"  xs="12" >
                  <v-text-field
                    v-model="dialogData.title"
                    label="Title"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col style="text-align: left;" cols="12" xs="12" >
                  <v-text-field
                    v-model="dialogData.logo"
                    label="Logo Url"
                    outlined
                  ></v-text-field>
                   <v-btn class="file_btn" color="primary" small outlined @click="showIconDialog">
                    FileBrowser
                  </v-btn>
                </v-col>
                <v-col cols="12" xs="12" >
                  <v-switch v-model="dialogData.clock" class="ma-2" label="Clock"></v-switch>
                </v-col>
             
              </v-row>
            </v-container>
        </v-card-text>
        <v-divider></v-divider>
         <v-card-actions style="padding:5px;padding-right:10px;">
          <v-btn class="dialog_btn" color="primary" text @click="detailJson">
            Confirm
          </v-btn>
          <div class="flex-grow-1"></div>
        </v-card-actions>
      </v-card>
    </v-dialog>  
</template>
<script>

//import icons from './materialicon.json';

export default {
    id: "#dockeBuilderHeaderDialog",
    $_veeValidate: {
        validator: 'new'
    },
     data () {
      return {
        iconDialog: false,
        value: '',
        dialogData: {},
        dialogState: false,
        deleteDialog: false,
        loading: false,
        dialog: false,
        error: true,
        errorLoading: false,
        errorMsg: '',
        result: [],
        isLoading: true,
        search: null,
        timeout: 3000       
      }
    },
    
     computed: {
      user (){
        return this.$store.getters.user;
      }
    },
    watch: {
      dialog (val) {
        val || this.close()
      }
    },
    components: {
       FileBrowser: () => import('../FileBrowser'),
       S3FileBrowser: () => import('../S3FileBrowser'),
    },
    async created() {
    },
     methods: {
      close() {
        this.$emit('closeDialog', false);
      },
      showIconDialog(){
        this.iconDialog = true;
      },
      selectIcon(icon){
        this.dialogData.logo = icon;
        this.iconDialog = false;
      },
      async detailJson(){
          this.dialog = false;
          this.$emit('saveDialog', this.dialogData);
        
      }    
    }
}
</script>
<style scoped>
.file_btn{
  text-transform: none;
  margin-top: -30px;
}
.v-virtual-scroll{
  overflow-x: hidden;
}
.json_editor{
  min-height: 500px;
  height: 100%;
}
.event_body{
   /* background-color:#e9fafb; */
}
.header_layout{
  margin-top: -5px;
}
.view_footer{
   z-index: 2;
}
.flash_box{
  float: right;
  /* margin-right: -15px; */
}

.event_header .v-toolbar__content{
   height: 45px;
}
.event-action{
    margin-right:15px;
    min-width: auto;
    line-height: 18pt;
  }

  .loading{
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left:0;
  z-index: 50;
  background-color: rgba(255, 255, 255, 0.4196078431372549);
}

  .list-item{
    border-bottom: 1px solid #c9c8c8;
  }
.table_btn{
  text-transform: unset;
}
.btn_add{
    /* bottom: 0;
    position: fixed;
    margin: 0 0 16px 16px;
    z-index: 5; */
    width: 30px !important;
    height: 30px !important;
}
.btn_add i{
  font-size: 20px !important;
}
</style>

<style>
.item_form .v-text-field__details{
  margin: 0 !important;
}
.xs_input .v-input__control{
    min-height: 37px !important;
}
.xs_input .v-input__slot{
    margin-bottom: 3px !important;
}
.xs_input .v-label{
  font-size: 12px !important;
}

.jsoneditor-vue{
  height: 100%;
}
.json-save-btn{
  padding: 8px 35px !important;
  margin-bottom: 20px;
}

</style>